module.exports = __webpack_public_path__ + "static/media/costpic2@3x.e0df7806.png";